<template>
  <div class="main-page">
    <Menu title="满意度评价" :home="true"></Menu>
    <div class="container-flex performance-block">
      <div class="perform-content-text">
        <div class="perform-content_title">
          请对机关履职情况进行满意度评价
        </div>
        <div class="perform-content_evaluate">
          <div class="eval-label">选择评价机构：</div>
          <div class="eval-select">
            <select name="" id="" class="province" v-show="showcity" @change="orgList = []" v-model="city">
              <option value='' disabled selected style='display:none;'>省市</option>
              <option :value="item.code" v-for="(item, index) in cityList" :key="index">{{ item.name }}</option>
            </select>
            <select name="" id="" class="province city" v-model="county" @change="setCity()">
              <option value='' disabled selected style='display:none;'>区县</option>
              <option :value="item.code" v-for="(item, index) in countyList" :key="index">{{ item.name }}</option>
            </select>
            <select name="" id="" class="province org" v-model="org" @change="setOrg()">
              <option value='' disabled selected style='display:none;'>机构</option>
              <option :value="item.department | departFilter" v-for="(item, index) in orgList" :key="index">
                {{ item.department | departFilter }}</option>
            </select>
          </div>

        </div>
        <div class="tip" v-if="city === '' || county === '' || org === ''">* 请选择机构</div>

        <div class="perform-content_evaluate">
          <div class="eval-label">您的满意度：</div>
          <div class="eval-select">
            <a class="eval-btn" :class="{ active: currentChecked1 === index }" @click="chooseEval(item, index, 1)"
              v-for="(item, index) in eval_tags" :key="index">{{ item.title }}</a>
          </div>
        </div>
        <div class="tip" v-if="currentChecked1 === ''">* 请选择满意度</div>
        <div class="perform-content_evaluate perform-content_problems" v-if="showWorkProblems">
          <div class="eval-label">存在问题：</div>
          <div class="eval-problems">
            <Option title='服务态度' type='work_evaluate' keys='service' @sendOption="receiveOptions" />
            <Option title='工作效率' type='work_evaluate' keys='efficiency' @sendOption="receiveOptions" />
            <Option title='办事环境' type='work_evaluate' keys='environment' @sendOption="receiveOptions" />
            <Option title='业务能力' type='work_evaluate' keys='capability' @sendOption="receiveOptions" />
            <Option title='廉洁自律' type='work_evaluate' keys='discipline' @sendOption="receiveOptions" />
          </div>
        </div>
        <div class="perform-content_evaluate perform-content_problems">
          <div class="eval-label">其他意见建议：</div>
          <textarea class="otherInfo" v-model="submit_data.work_evaluate.other_evaluate" id="xz_qtyj"
            placeholder="针对服务态度,工作效率,办事环境,业务能力,廉洁自律等方面的具体意见"></textarea>
        </div>
      </div>

      <div class="perform-content-text text2">
        <div class="perform-content_title">
          请对<span class="org" v-if="org"> {{ org }} </span>以下工作进行满意度评价
        </div>
        <div class="perform-content_evaluate perform-content_problems">
          <div class="eval-label">选择分类：</div>
          <div class="eval-select eval-select-category">
            <a class="select-category-btn" v-for="(item, index) in category" :key="index"
              :class="{ 'last-category': index > 17, 'active': currentType === index }"
              @click="chooseType(item, index)">{{ item.title }}</a>

          </div>
        </div>
        <div class="tip" v-if="currentType === ''">* 请选择分类</div>
        <div class="perform-content_evaluate">
          <div class="eval-label">您的满意度：</div>
          <div class="eval-select">
            <a class="eval-btn" v-for="(item, index) in eval_tags" :key="index" @click="chooseEval(item, index, 2)"
              :class="{ active: currentChecked2 === index }">{{ item.title }}</a>
          </div>
        </div>
        <div class="tip" v-if="currentChecked2 === ''">* 请选择满意度</div>
        <div class="perform-content_evaluate perform-content_problems" v-if="showBusProblems">
          <div class="eval-label">存在问题：</div>
          <div class="eval-problems">
            <Option title='服务态度' type='bus_evaluate' keys='service' @sendOption="receiveOptions" />
            <Option title='工作效率' type='bus_evaluate' keys='efficiency' @sendOption="receiveOptions" />
            <Option title='办事环境' type='bus_evaluate' keys='environment' @sendOption="receiveOptions" />
            <Option title='业务能力' type='bus_evaluate' keys='capability' @sendOption="receiveOptions" />
            <Option title='廉洁自律' type='bus_evaluate' keys='discipline' @sendOption="receiveOptions" />
          </div>
        </div>
        <div class="perform-content_evaluate perform-content_problems">
          <div class="eval-label">其他意见建议：</div>
          <textarea class="otherInfo" v-model="submit_data.bus_evaluate.other_evaluate" id="xz_qtyj"
            placeholder="针对服务态度,工作效率,办事环境,业务能力,廉洁自律等方面的具体意见"></textarea>
        </div>
      </div>
      <div class="perform-control">
        <!-- <a class="perform-control-btn"
           >取消</a> -->
        <a class="perform-control-btn submit-btn" @click="submit()">提交评价</a>
      </div>
      <p class="sub-tip">说明：请客观提出满意度评价，并自觉遵守国家有关法律法规，不得发表违法和不适当的言论</p>
      <Alert v-if="alert.show" :info="alert.info" :recall="alert.recall" @setClose="value => alert.show = value" />
    </div>
    <div class="mask" v-if="success"></div>
    <div class="success-tip" v-if="success">
      <img src="/img/ui/submit.png" alt="">
      <p class="success-words">评价成功</p>
      <div class="back">
        <router-link class="backhome" to="/">返回首页</router-link>
      </div>

    </div>
  </div>
</template>

<script>
import Menu from '../components/Menu'
import PerformanceOption from '../components/PerformanceOption'
import Alert from '@/components/Alert'
import { SATISFACTION } from '../datas/constants/statistics.js'
export default {
  components: {
    Menu,
    Option: PerformanceOption,
    Alert
  },
  filters: {
    departFilter (value) {
      if (value.indexOf('/') !== -1) {
        return value.split('/')[1]
      } else {
        return value
      }
    }
  },
  watch: {
    city () {
      let code = this.city.toString()
      if (code === '530000') {
        this.getCity('', 2)
      } else {
        this.getCity(code, 2)
      }
    },
    county () {
      let code = this.county.toString()
      this.getOrg(code)
    }
  },
  data () {
    /**
     * @property {Array} options 子组件整体满意度评价选项
     * @property {String} org 选择的机构
     * @property {String} city 选择的城市
     * @property {String} county 选择的区县
     * @property {String} currentChecked1 对履职情况整体满意度评价
     * @property {String} currentChecked2 对工作业务整体满意度评价
     * @property {String} currentType 选择的评价分类
     * @property {Array} eval_tags 整体满意度评价选项
     * @property {Array} category 评价分类
     * @property {Object} submit_data 最后提交的数据
     * @property {String} cityList 获取的城市列表
     * @property {String} countyList 获取的区县列表
     * @property {String} orgList 获取的机构列表
     * @property {Boolean} success 控制评价成功提示是否显示
     * @property {Number} time 评价成功提示倒数时间
    */
    return {

      options: ['满意', '基本满意', '不满意'],
      org: '',
      city: '',
      county: '',
      currentChecked1: '',
      currentChecked2: '',
      currentType: '',
      eval_tags: [
        { title: '满意', id: '1', isChecked: false },
        { title: '基本满意', id: '2', isChecked: false },
        { title: '不满意', id: '3', isChecked: false }
      ],

      category: [
        { title: '证明事项清理投诉监督', id: '1' },
        { title: '留言咨询', id: '2' },
        { title: '律师案件委托', id: '3' },
        { title: '公证预约', id: '4' },
        { title: '公证申请', id: '5' },

        { title: '法律援助申请', id: '6' },
        { title: '人民调解预约', id: '7' },
        { title: '人民调解申请', id: '8' },
        { title: '司法鉴定委托', id: '9' },
        { title: '投诉举报', id: '10' },
        { title: '人民调解', id: '21' },
        { title: '法律援助', id: '22' },
        { title: '公证', id: '23' },
        { title: '司法鉴定', id: '24' },
        { title: '仲裁', id: '25' },
        { title: '律师', id: '26' },
        { title: '国家统一法律职业资格考试', id: '27' },
        { title: '法治宣传', id: '28' },
        { title: '其他', id: '11' }

      ],
      submit_data: {
        'work_evaluate': { // 履职满意度
          'department': '', // 被评价单位
          'xzqh_name': '', // 行政区划名称
          'xzqh': '', // 行政区划代码
          'overall_evaluate': '', // 一级指标
          'data_sources': '02', // 数据来源
          'pjqd': '5', // 评价渠道
          'other_evaluate': '', // 其他意见和评价
          'service': '', // 二级指标-服务态度
          'efficiency': '', // 二级指标-效率
          'environment': '', // 二级指标-环境
          'capability': '1', // 二级指标-能力
          'discipline': '' // 二级指标-廉洁
        },
        'bus_evaluate': { // 工作业务满意度
          'department': '',
          'xzqh_name': '',
          'xzqh': '',
          'service_type': '',
          'overall_evaluate': '',
          'data_sources': '02',
          'pjqd': '5',
          'other_evaluate': '',
          'service': '',
          'efficiency': '',
          'environment': '',
          'capability': '',
          'discipline': ''
        },
        appkey: ''
      },
      cityList: '',
      countyList: '',
      orgList: '',
      success: false,
      time: 10,
      showcity: true,
      alert: {
        info: '',
        show: false,
        recall: () => { }
      }
    }
  },
  computed: {
    code () {
      return this.$store.state.device.point.code
    },
    /**
     * @function showWorkProblems
     * @description 监听控制 履职满意度中的 存在问题选择框显示
    */
    showWorkProblems () {
      if (!this.submit_data.work_evaluate.overall_evaluate || this.submit_data.work_evaluate.overall_evaluate === '1') {
        return false
      } else {
        return true
      }
    },
    /**
     * @function showBusProblems
     * @description 监听控制 工作业务满意度中 存在问题选择框显示
    */
    showBusProblems () {
      if (!this.submit_data.bus_evaluate.overall_evaluate || this.submit_data.bus_evaluate.overall_evaluate === '1') {
        return false
      } else {
        return true
      }
    }

  },
  async mounted () {
    this.$root.getStatistics(SATISFACTION)
    await this.getCity('', 1)
    const { appkey, code } = this.$route.params
    if (!appkey || !code) {
      this.alert.info = '获取参数错误'
      this.alert.show = true
      return
    }
    this.submit_data.appkey = appkey
    this.city = code
    if (code !== '530000') {
      this.showcity = false
    }
    const { config, point } = this.$store.state.device
    console.log(config, point)
    this.city = config.web_code
    this.county = point.code
    if (this.county) {
      this.submit_data.work_evaluate.xzqh = this.county.toString()
      this.submit_data.work_evaluate.xzqh_name = point.area
      this.submit_data.bus_evaluate.xzqh = this.county.toString()
      this.submit_data.bus_evaluate.xzqh_name = point.area
    }
  },
  methods: {
    /**
     * @function getCity
     * @description 获取城市及区县列表
     * @param code 城市区县编码
     * @param type 区分存入城市列表 或 区县列表
    */

    async getCity (code, type) {
      let { result, msg, status } = await this.$get(`pufa/satisfied/area/list/?code=${code}`)
      if (!status) {
        console.log('error', msg)
      }
      type === 1 ? this.cityList = result.data : this.countyList = result.data
    },
    /**
     * @function getOrg
     * @description 获取机构列表
     * @param code 机构编码
    */

    async getOrg (code) {
      let { result, msg, status } = await this.$get(`pufa/satisfied/org/list/?code=${code}`)
      if (!status) {
        console.log('error', msg)
      }
      this.orgList = result.data
    },

    /**
     * @function setCity
     * @description 把选择的地区存入要提交的数据中
    */

    setCity () {
      for (let i = 0; i < this.countyList.length; i++) {
        if (this.county === this.countyList[i].code) {
          this.submit_data.work_evaluate.xzqh = this.county.toString()
          this.submit_data.work_evaluate.xzqh_name = this.countyList[i].name
          this.submit_data.bus_evaluate.xzqh = this.county.toString()
          this.submit_data.bus_evaluate.xzqh_name = this.countyList[i].name
        }
      }
      this.org = ''
    },

    /**
     * @function setOrg
     * @description 把选择的机构存入要提交的数据中
    */

    setOrg () {
      this.submit_data.work_evaluate.department = this.org
      this.submit_data.bus_evaluate.department = this.org
    },

    /**
     * @function receiveOptions
     * @description 把从子组件中获取的存在问题满意度评价存到要提交的数据中
     * @param type 区分履职满意度评价work_evaluate 和 工作业务满意度评价bus_evaluate
     * @param keys 具体二级评价指标
     * @param value 评价的传值 （'1' 满意, '2' 基本满意, '3' 不满意）
    */

    receiveOptions (type, keys, value) {
      // console.log('type', type, keys, value)
      this.submit_data[type][keys] = value.toString()
      // console.log('11111', this.submit_data[type][keys])
    },

    /**
     * @function chooseEval
     * @description 选择一级指标评价
     * @param item 每个评价标签
     * @param index 每个评价标签的索引
     * @param step 区分履职满意度评价 1 和 工作业务满意度评价 2
    */

    chooseEval (item, index, step) {
      if (step === 1) {
        this.currentChecked1 = index
        item.isChecked = !item.isChecked
        this.submit_data.work_evaluate.overall_evaluate = item.id
      } else if (step === 2) {
        this.currentChecked2 = index
        item.isChecked = !item.isChecked
        this.submit_data.bus_evaluate.overall_evaluate = item.id
      }
    },

    /**
     * @function chooseType
     * @description 选择评价工作业务的分类
     * @param item 评价分类里的每个单独的类别
     * @param index 每个单独的类别的索引
    */

    chooseType (item, index) {
      this.currentType = index
      this.submit_data.bus_evaluate.service_type = item.id
    },

    /**
     * @function submit
     * @description 提交评价数据
    */
    async submit () {
      if (this.submit_data.work_evaluate.department === '' ||
        this.submit_data.bus_evaluate.department === '' ||
        this.submit_data.work_evaluate.xzqh_name === '' ||
        this.submit_data.bus_evaluate.xzqh_name === '' ||
        this.submit_data.work_evaluate.xzqh === '' ||
        this.submit_data.bus_evaluate.xzqh === '') {
        this.alert.info = '您未选择评价机构！'
        this.alert.show = true
        return
      }
      if (this.currentChecked1 !== 0 && (
        this.submit_data.work_evaluate.service === '' ||
        this.submit_data.work_evaluate.efficiency === '' ||
        this.submit_data.work_evaluate.capability === '' ||
        this.submit_data.work_evaluate.environment === '' ||
        this.submit_data.work_evaluate.discipline === '')) {
        this.alert.info = '您未选择机关履职情况存在问题！'
        this.alert.show = true
        return
      } else if (this.currentChecked1 === 0) {
        this.submit_data.work_evaluate.service = '1'
        this.submit_data.work_evaluate.efficiency = '1'
        this.submit_data.work_evaluate.capability = '1'
        this.submit_data.work_evaluate.environment = '1'
        this.submit_data.work_evaluate.discipline = '1'
      }
      if (this.currentType === '') {
        this.alert.info = '您未选择分类！'
        this.alert.show = true
        return
      }
      if (this.currentChecked2 !== 0 && (
        this.submit_data.bus_evaluate.service === '' ||
        this.submit_data.bus_evaluate.efficiency === '' ||
        this.submit_data.bus_evaluate.capability === '' ||
        this.submit_data.bus_evaluate.environment === '' ||
        this.submit_data.bus_evaluate.discipline === '')) {
        this.alert.info = '您未选择工作存在问题！'
        this.alert.show = true
        return
      } else if (this.currentChecked2 === 0) {
        this.submit_data.bus_evaluate.service = '1'
        this.submit_data.bus_evaluate.efficiency = '1'
        this.submit_data.bus_evaluate.capability = '1'
        this.submit_data.bus_evaluate.environment = '1'
        this.submit_data.bus_evaluate.discipline = '1'
      }
      const orgdata = await this.$api.setEvaluateNet({
        ... this.submit_data
      })
      if (orgdata) {
        this.success = true
      }
    },
    /**
     * @function closeSuccessPop
     * @description 关闭提交成功提示
    */

    closeSuccessPop () {
      this.success = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.container-flex
  &.performance-block
    position relative
    height 100%
    width 12.46rem
    padding 0.4rem 0.5rem 0.98rem 0.5rem
    overflow-y scroll
    background #fff
    border-radius 0.1rem
    webkit-overflow-scrolling touch
    box-sizing border-box
    margin 0 auto
.perform-content_title
  font-family MicrosoftYaHei-Bold
  font-size 0.32rem
  line-height 0.32rem
  color #333333
  font-weight 600
  span.org
    color #5168b6
    font-weight 600
.perform-content_evaluate
  display flex
  align-items center
  margin-top 0.4rem
  &.perform-content_problems
    align-items flex-start
    margin-top 0.3rem
  &.problem1
    margin-top 0.2rem
  &.problem2
    margin-top 0.2rem
  .eval-label
    color #333
    font-size 0.2rem
    text-align right
    width 1.4rem
  .eval-select
    display flex
    margin-left 0.25rem
    flex-wrap wrap
  .province
    width 1.8rem
    height 0.4rem
    border 0.01rem solid #e5e5e5
    font-size 0.2rem
    display flex
    justify-content space-between
    align-items center
    padding 0 0.14rem
    color #333
    margin-right 0.2rem
    &.city
      width 2.1rem
    &.org
      width 2.7rem
    option
      font-size 0.17rem
  .eval-btn
    display block
    width 1.2rem
    height 0.45rem
    border solid 0.01rem #e5e5e5
    text-align center
    line-height 0.45rem
    margin-right 0.2rem
    color #333
    font-size 0.2rem
    &.active
      border 0.02rem solid #5168b6
      text-align center
      line-height 0.4rem
      color #5168b6
      position relative
      &:after
        content url('/wstatic/img/icon/induce1.png')
        width 0.07rem
        height 0.055rem
        bottom 0.19rem
        position absolute
        right -0.01rem
      &:before
        content ''
        width 0
        height 0
        right 0
        bottom 0
        border 0.05rem solid transparent
        border-right 0.05rem solid transparent
        border-bottom 0.05rem solid transparent
        border-style solid
        position absolute
        border-bottom-color #5168b6
        border-right-color #5168b6
  .eval-problems
    width 7.82rem
    height 3.55rem
    background-color #f5f5f7
    margin-left 0.25rem
    padding-top 0.08rem
.text2
  padding-top 0.8rem
  .select-category-btn
    display flex
    padding 0.088rem 0.15rem
    border 0.01rem solid #e5e5e5
    margin-right 0.1rem
    margin-bottom 0.1rem
    color #333
    font-size 0.2rem
    &.active
      border 0.02rem solid #5168b6
      text-align center
      color #5168b6
      position relative
      &:after
        content url('/wstatic/img/icon/induce1.png')
        width 0.07rem
        height 0.05rem
        bottom 0.06rem
        position absolute
        right -0.01rem
      &:before
        content ''
        width 0
        height 0
        right 0
        bottom 0
        border 0.05rem solid transparent
        border-right 0.05rem solid transparent
        border-bottom 0.05rem solid transparent
        border-style solid
        position absolute
        border-bottom-color #5168b6
        border-right-color #5168b6
  .eval-select-category
    width 7.82rem
.tip
  color #e73131
  font-size 0.19rem
  margin-left 1.62rem
  margin-top 0.14rem
  &.tip-options
    margin 0
.perform-control
  margin 0 auto
  width 4.5rem
  height 0.46rem
  display flex
  justify-content center
  color #5168b6
  font-size 0.16rem
  margin-top 0.5rem
  .perform-control-btn
    width 2.1rem
    height 0.54rem
    border 0.01rem solid #5168b6
    color #5168b6
    font-size 0.22rem
    text-align center
    line-height 0.54rem
    background #fff
    color #5168b6
    &.submit-btn
      background #5168b6
      color #fff
.sub-tip
  text-align center
  font-size 0.19rem
  color #e73131
  margin-top 0.3rem
a:hover
  color #333
.otherInfo
  padding 0.1rem
  width 7.82rem
  height 1.8rem
  margin-left 0.25rem
  border-color #e5e5e5
.mask
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 400
  background rgba(0, 0, 0, 0.4)
.success-tip
  width 9rem
  height 4.8rem
  background #ffffff
  position fixed
  top 3.5rem
  left 50%
  margin-left -4.5rem
  padding-top 0.6rem
  text-align center
  z-index 9999
  border 1px solid #e5e5e5
  img
    margin-bottom 0.4rem
  .success-words
    font-size 0.24rem
    font-weight 600
    margin-bottom 0.19rem
  .thanks
    font-size 0.18rem
    span
      color red
  .back
    display block
    width 1.5rem
    height 0.54rem
    background-color #ffffff
    border solid 0.01rem #546db9
    margin 0 auto
    line-height 0.54rem
    margin-top 0.5rem
    .backhome
      font-size 0.22rem
      color #546db9
  .close-icon
    position absolute
    top 0.2rem
    right 0.2rem
</style>
